import { gql } from 'apollo-angular';

export const GET_PRODUCT_VARIANTS_BY_COLLECTION = gql`
    query GetProductVariantsByCollection($collectionSlug: String!, $options: ProductVariantListOptions) {
        collection(slug: $collectionSlug) {
            id
            name
            productVariants(options: $options) {
                totalItems
                items {
                    id
                    name
                    sku
                    featuredAsset {
                        id
                        preview
                        focalPoint {
                            x
                            y
                        }
                    }
                    product {
                        id
                        featuredAsset {
                            id
                            preview
                            focalPoint {
                                x
                                y
                            }
                        }
                    }
                }
            }
        }
    }
`;
